module.exports = "<ion-content>\n  <app-grid-overspeed [overSpeed]='overSpeedReport'></app-grid-overspeed>\n\n</ion-content>"